import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2113Status: 'idle',
    startProcess2113Error: undefined as any,
    loadUserParamsProcess2113Status: 'idle',
    loadUserParamsProcess2113Error: undefined as any,

    process2113List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2113 = createAsyncThunk('process2113Slice/startProcess2113', async ({ process2113 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2113/`,
        prepareData(process2113),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2113Status } = getState().process2113Slice
        return startProcess2113Status !== 'pending'
    }
})

export const loadUserParamsProcess2113 = createAsyncThunk('process2113Slice/loadUserParamsProcess2113', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2113/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2113Status } = getState().process2113Slice
        return loadUserParamsProcess2113Status !== 'pending'
    }
})

const Process2113Slice = createSlice({
    name: 'process2113Slice',
    initialState,
    reducers: {
        resetstartProcess2113: (state) => {
            state.job = undefined
            state.startProcess2113Error = undefined
        },
        resetstartProcess2113Error: (state) => {
            state.startProcess2113Error = undefined
        },
        resetloadUserParamsProcess2113: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2113Error = undefined
        },
        resetloadUserParamsProcess2113Error: (state) => {
            state.loadUserParamsProcess2113Error = undefined
        },
        removeFromProcess2113ListById: (state, action) => {
            state.process2113List = state.process2113List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2113ListByIds: (state, action) => {
            state.process2113List = state.process2113List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2113List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2113Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2113List = []
            state.startProcess2113Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2113.pending, (state) => {
            state.startProcess2113Status = 'pending'
            state.startProcess2113Error = undefined
        })
        builder.addCase(startProcess2113.fulfilled, (state, action) => {
            state.startProcess2113Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2113.rejected, (state, action) => {
            state.startProcess2113Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2113Error = action.error.message
            } else {
                state.startProcess2113Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2113.pending, (state) => {
            state.loadUserParamsProcess2113Status = 'pending'
            state.loadUserParamsProcess2113Error = undefined
        })
        builder.addCase(loadUserParamsProcess2113.fulfilled, (state, action) => {
            state.loadUserParamsProcess2113Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2113.rejected, (state, action) => {
            state.loadUserParamsProcess2113Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2113Error = action.error.message
            } else {
                state.loadUserParamsProcess2113Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2113,
    resetstartProcess2113Error,
    resetloadUserParamsProcess2113,
    resetloadUserParamsProcess2113Error,
    removeFromProcess2113ListById,
    removeFromProcess2113ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2113Slice.actions
export default Process2113Slice.reducer
